export default {
  安全提示: "安全提示",
  安全提示內容: "為保障帳戶安全，建議您立即修改密碼。",
  去修改密码: "去修改密碼",
};
